
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">Use a button to carry out an action.</Paragraph>
    <h2>{`Anatomy`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Constraint`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Label`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Mandatory`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Icon`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Use of labels`}</h3>
    <p>{`Labels show users what will happen when they click the button.`}</p>
    <ul>
      <li parentName="ul">{`Should be clear and distinct.`}</li>
      <li parentName="ul">{`Use verbs that describe the action, such as Send, Add or Delete.`}</li>
      <li parentName="ul">{`Keep it short, no more than 3 words.`}</li>
    </ul>
    <h3>{`Use of icons`}</h3>
    <p>{`Button with an icon indicates a specific action and it reinforces or clarifies the meaning of a label.
Icons can be on right or left of your label.`}</p>
    <h3>{`Colour`}</h3>
    <p>{`Ensure that the button background colour or label colour in the case of the text button provides sufficient contrast with the context/section background.`}</p>
    <h2>{`When to use`}</h2>
    <p>{`To trigger an action. `}<em parentName="p">{` Actions which affect the website's state are buttons. `}</em>{`
Actions include: Search, Submit... etc.`}</p>
    <p>{`An action is performed when the user interact actively with the website, ex: the user post a comment.`}</p>
    <p>{`There are 5 types of buttons with 5 different use cases.
The button with the strongest visual weight will attract the most attention.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Button name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Visual style`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Usage`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Call-to-action (CTA) button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Buttons/Button_CTA_Default.png",
              "alt": "Button Image"
            }}></img></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`funnel users into the most important action for your business ex: "Apply for funding" or "Watch live streaming". Limit to one CTA on a given page, the same CTA can be repeated within in the page.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Primary button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Buttons/Button_Primary_Default.png",
              "alt": "Button Image"
            }}></img></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Only 1 primary action per context/section of the page, Primary buttons can appear in a few occurence on a page. ex: "submit","register"...`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Secondary button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Buttons/Button_Secondary_Default.png",
              "alt": "Button Image"
            }}></img></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Secondary action that users can perform on the page and it can be used multiple times per context/section in the page. ex: "show more", "expand", "see details".`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Text button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Buttons/Button_Ghost_Default.png",
              "alt": "Button Image"
            }}></img></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`When an action does not require dominance on a page. Often use next to a primary action ex: On a form context/section "Submit" as primary, "Cancel" as a text.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Search button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Buttons/Button_Search_Default.png",
              "alt": "Button Image"
            }}></img></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`use exclusively for the search function.`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`When not to use`}</h2>
    <p>{`For navigational purposes. If the action triggered sends a user to a different page, opens up a page in a new tab or jump to another section within the current page, use `}<Link to="/ec/components/navigation/link/usage/" mdxType="Link">{`links`}</Link>{` instead because these actions don’t change anything on the website’s state.
The user is passive, browsing through content (read only).`}</p>
    <h2>{`DO's`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Avoid using icons on buttons`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`When you do need icons:`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`For LTR languages, left aligned icon flows better with the text.`}</p>
            <p parentName="li">{`illustration: Primary button, label "Approve", icon left "check"`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Place icons to the right for buttons with multiple status ex: expand/collapse buttons`}</p>
            <p parentName="li">{`illustration: Secondary button, label "Expand" icon right "arrow-down"`}</p>
          </li>
        </ul>
      </li>
    </ul>
    <h2>{`DON'Ts`}</h2>
    <ul>
      <li parentName="ul">{`Use button for navigation, use `}<Link to="/ec/components/navigation/link/usage/" mdxType="Link">{`links`}</Link>{` instead.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;